import { h } from 'preact';
import { withTranslation } from "react-i18next";
import { AppConstant } from '../../constant/AppConstant';
import style from './style.css';

function BackButton({ app, t }) {
    const backlink = app.state.backlink;
    const isBrowserBack = backlink === 'back';

    const handleBrowserBack = (e) => {
        e.preventDefault();
        window.history.back();
    };

    return (
        <span class={style.backButtonWrap}>
            {backlink && (
                <a
                    href={isBrowserBack ? '#' : backlink}
                    onClick={isBrowserBack ? handleBrowserBack : undefined}
                    class={style.backChevron}
                    aria-label={t(AppConstant.BACK)}
                >
                    <span class="fa fa-chevron-left" aria-hidden="true" />
                </a>
            )}
            <a href="/sites" aria-label="Kegtron">
                <img
                    src="/assets/images/KegtronLogoBlack.png"
                    height="24"
                    alt="Kegtron"
                    class={style.logoImg}
                />
            </a>
        </span>
    );
}
export default withTranslation()(BackButton);
